export const defaultState = {
    firstStepStartedAt: null,
    firstStepCompletedAt: null,
    isAutoDigitised: false,
    autoDigitisationAssistEnabled: false,
    autoDigitisationInfo: {},
    pastDigitisations: [],
};

export default function digitsation(state = defaultState, action) {
    switch (action.type) {
        case 'SET_DIGITISATION': {
            return Object.assign({}, state, action.payload);
        }
        case 'SET_FIRST_STEP_STARTED_AT': {
            return {
                ...state,
                firstStepStartedAt: action.payload,
            };
        }
        case 'SET_FIRST_STEP_COMPLETED_AT': {
            return {
                ...state,
                firstStepCompletedAt: action.payload,
            };
        }
        case 'SET_IS_AUTO_DIGITISED': {
            return Object.assign({}, state, {
                isAutoDigitised: action.payload,
            });
        }
        case 'TOGGLE_AUTO_DIGITISATION_ASSISTANT': {
            return Object.assign({}, state, {
                autoDigitisationAssistEnabled: !state.autoDigitisationAssistEnabled,
            });
        }
        case 'SET_AUTO_DIGITISATION_INFO': {
            return Object.assign({}, state, {
                autoDigitisationInfo: action.payload,
            });
        }
        default:
            return state;
    }
}
